import { Directive, HostBinding, Input } from '@angular/core';

function isAddClass(isReq: any = true): boolean {
  return isReq === '' || (isReq !== false && isReq !== 'false');
}

@Directive({
  selector: `jd-row[jd-wrap-reverse],[row][jd-wrap-reverse],jd-row[jd-align-items-center],[row][jd-align-items-center],jd-row[jd-nowrap],[row][jd-nowrap],jd-row[jd-align-items-start],[row][jd-align-items-start], jd-row[jd-align-items-end],[row][jd-align-items-end],jd-row[jd-align-items-stretch],[row][jd-align-items-stretch],jd-row[jd-align-items-baseline],[row][jd-align-items-baseline], jd-row[jd-justify-content-start],[row][jd-justify-content-start],jd-row[jd-justify-content-center],[row][jd-justify-content-center], jd-row[jd-justify-content-end],[row][jd-justify-content-end], jd-row[jd-justify-content-around],[row][jd-justify-content-around],jd-row[jd-justify-content-between],[row][jd-justify-content-between]`
})
export class JdRowExpDirective {
  private _wrapReverse = false;
  private _alignItemsCenter = false;
  private _nowrap = false;
  private _alignItemsStart = false;
  private _alignItemsEnd = false;
  private _alignItemsStretch = false;
  private _alignItemsBaseline = false;
  private _justifyContentStart = false;
  private _justifyContentCenter = false;
  private _justifyContentEnd = false;
  private _justifyContentAround = false;
  private _justifyContentBetween = false;

  @HostBinding('class.justify-content-between')
  @Input('jd-justify-content-between')
  set justifyContentBetween(value: boolean) {
    this._justifyContentBetween = isAddClass(value);
  }

  get justifyContentBetween() {
    return this._justifyContentBetween;
  }

  @HostBinding('class.justify-content-around')
  @Input('jd-justify-content-around')
  set justifyContentAround(value: boolean) {
    this._justifyContentAround = isAddClass(value);
  }

  get justifyContentAround() {
    return this._justifyContentAround;
  }

  @HostBinding('class.justify-content-end')
  @Input('jd-justify-content-end')
  set justifyContentEnd(value: boolean) {
    this._justifyContentEnd = isAddClass(value);
  }

  get justifyContentEnd() {
    return this._justifyContentEnd;
  }

  @HostBinding('class.justify-content-center')
  @Input('jd-justify-content-center')
  set justifyContentCenter(value: boolean) {
    this._justifyContentCenter = isAddClass(value);
  }

  get justifyContentCenter() {
    return this._justifyContentCenter;
  }

  @HostBinding('class.justify-content-start')
  @Input('jd-justify-content-start')
  set justifyContentStart(value: boolean) {
    this._justifyContentStart = isAddClass(value);
  }

  get justifyContentStart() {
    return this._justifyContentStart;
  }

  @HostBinding('class.align-items-baseline')
  @Input('jd-align-items-baseline')
  set alignItemsBaseline(value: boolean) {
    this._alignItemsBaseline = isAddClass(value);
  }

  get alignItemsBaseline() {
    return this._alignItemsBaseline;
  }

  @HostBinding('class.align-items-stretch')
  @Input('jd-align-items-stretch')
  set alignItemsStretch(value: boolean) {
    this._alignItemsStretch = isAddClass(value);
  }

  get alignItemsStretch() {
    return this._alignItemsStretch;
  }

  @HostBinding('class.align-items-end')
  @Input('jd-align-items-end')
  set alignItemsEnd(value: boolean) {
    this._alignItemsEnd = isAddClass(value);
  }

  get alignItemsEnd() {
    return this._alignItemsEnd;
  }

  @HostBinding('class.align-items-start')
  @Input('jd-align-items-start')
  set alignItemsStart(value: boolean) {
    this._alignItemsStart = isAddClass(value);
  }

  get alignItemsStart() {
    return this._alignItemsStart;
  }

  @HostBinding('class.nowrap')
  @Input('jd-nowrap')
  set nowrap(value: boolean) {
    this._nowrap = isAddClass(value);
  }

  get nowrap() {
    return this._nowrap;
  }

  @HostBinding('class.wrapReverse')
  @Input('jd-wrap-reverse')
  set wrapReverse(value: boolean) {
    this._wrapReverse = isAddClass(value);
  }

  get wrapReverse() {
    return this._wrapReverse;
  }

  @HostBinding('class.align-items-center')
  @Input('jd-align-items-center')
  set alignItemsCenter(value: boolean) {
    this._alignItemsCenter = isAddClass(value);
  }

  get alignItemsCenter() {
    return this._alignItemsCenter;
  }

  constructor() {}
}
